import { Modal, Form, Input, notification, Select } from "antd";
import { useCreateTaskMutation } from "shared/api";
import { useEffect } from "react";
import dayjs from "dayjs";

interface AddSimpleTaskModalProps {
  open: boolean;
  onClose: () => void;
  currentProductCardId: number;
  currentUserId: number;
}

export const AddSimpleTaskModal: React.FC<AddSimpleTaskModalProps> = ({
  open,
  onClose,
  currentProductCardId,
  currentUserId,
}) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [createTask, { isLoading }] = useCreateTaskMutation();
  const now = dayjs().format("YYYY-MM-DDTHH:mm:ss");

  const params = new URLSearchParams(window.location.search);
  const currentMachineId = Number(params.get("machine"));

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open]);

  const handleFinish = async (values: any) => {
    try {
      const payload = {
        name: values.name,
        description: values.description,
        is_recurrent: false,
        machines: [currentMachineId],
        users: [currentUserId],
        product_cards: [currentProductCardId],
        periodicity: null,
        priority: values.priority,
        time: null,
        start_periodicity: now,
        end_periodicity: null,
        enabled: true,
      };

      await createTask(payload).unwrap();

      api.success({
        message: "Task Created",
        description: "The task was successfully created.",
        placement: "topRight",
      });

      onClose();
    } catch (err) {
      api.error({
        message: "Task Creation Failed",
        description: "Something went wrong while creating the task.",
        placement: "topRight",
      });
      // eslint-disable-next-line no-console
      console.error("Failed to create task", err);
    }
  };

  return (
    <>
      {contextHolder}
      <Modal
        centered
        open={open}
        onCancel={onClose}
        onOk={() => form.submit()}
        confirmLoading={isLoading}
        destroyOnClose
        title={
          <span style={{ fontSize: "20px", fontWeight: 500 }}>Add Task</span>
        }
        okButtonProps={{
          style: {
            backgroundColor: "#1677ff",
            color: "#fff",
            borderColor: "#1677ff",
          },
        }}
      >
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            name="name"
            label={
              <span style={{ fontSize: "18px", fontWeight: 400 }}>
                Task Name
              </span>
            }
            rules={[{ required: true, message: "Please enter task name" }]}
          >
            <Input placeholder="Enter task name" size="large" />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Please enter description" }]}
            name="description"
            label={
              <span style={{ fontSize: "18px", fontWeight: 400 }}>
                Description
              </span>
            }
          >
            <Input.TextArea
              size="large"
              rows={4}
              placeholder="Enter task description (optional)"
            />
          </Form.Item>

          <Form.Item
            name="priority"
            label={
              <span style={{ fontSize: "18px", fontWeight: 400 }}>
                Priority
              </span>
            }
            rules={[{ required: true, message: "Please select priority" }]}
          >
            <Select size="large" placeholder="Select priority">
              <Select.Option value={1}>1</Select.Option>
              <Select.Option value={2}>2</Select.Option>
              <Select.Option value={3}>3</Select.Option>
              <Select.Option value={4}>4</Select.Option>
              <Select.Option value={5}>5</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
